<template>
    <div>
        <!-- 主要艺人 -->
        <el-form-item prop="mainArtist" label="演唱艺人">
            <!-- 平台艺人关联进度条 -->
            <ArtistPlatformProgress
                v-if="hasArtist"
                :stats-data="thirdPartyPlatformStats"
                :artist-progress-data="artistProgressData"
                :is-editable="!disabled"
                :wrap-layout="true"
                @handle-click="toReleaseArtistDrawer"
            ></ArtistPlatformProgress>
            <p style="font-size: 12px; color: #c0c4cc;" v-if="hasArtist">
                建议提前关联各平台艺人主页，可减少作品进入错误主页的情况
                <span
                    style="cursor: pointer; color: #188df7; margin-left: 10px; border: 1px solid #4d8cff; border-radius: 5px; padding: 5px 10px; font-size: 12px;"
                    @click="toReleaseArtistDrawer"
                >
                    关联平台艺人
                </span>
            </p>
            <ArtistSelect :disabled="disabled" :data="mainArtist" @change="mainArtistChange"></ArtistSelect>
        </el-form-item>

        <!-- 其他艺人 -->
        <el-form-item prop="otherArtist" :rules="[{required: true, message: '请填写词曲作者'}]" v-if="isOtherArtist" label="其他艺人">
            <div v-if="ifAppleVerify && projectRoleArtistInfo && projectRoleArtistInfo.length" style="font-size: 12px; color: rgb(192, 196, 204)">
                工程制作人员分组角色任意填写一个即可通过校验:{{ projectRoleArtistTips }}
            </div>
            <div class="other-artist" v-for="(item, index) in otherArtist" :key="index">
                <el-select
                    :value="item.type"
                    :filterable="true"
                    placeholder="请选择"
                    :disabled="disabled"
                    @input="otherArtistTypeChange($event, index)"
                >
                    <el-option
                        v-for="t in artistTypeOptions"
                        :key="t.value"
                        :label="t.label"
                        :value="t.value"
                        :disabled="artistTypeSelected.includes(t.value)"
                    ></el-option>
                </el-select>
                <ArtistSelect
                    :disabled="disabled || !item.type"
                    :data="item.artist"
                    @change="otherArtistChange($event, index)"
                    :placeholder="placeholderText(item.type)"
                ></ArtistSelect>
                <el-button v-if="index === 0" :disabled="disabled" class="underline" type="text" @click="otherArtistAddItem">添加</el-button>
                <el-button v-else type="text" class="underline" @click="otherArtistRemoveItem(index)">删除</el-button>
            </div>
        </el-form-item>
        <album-release-dialog
            ref="albumReleaseDialogRef"
            :all-artist-info="allArtistInfo"
            :all-artist-value-options="allArtistValueOptions"
            :is-album="isAlbum"
            :display-lang-code="displayLangCode"
        ></album-release-dialog>
    </div>
</template>

<script>
import ArtistSelect from '../ArtistSelect';
import {fetchArtistType} from '@/api/common';
import {fetchListRelateArtist} from '@/api/album';
import AlbumReleaseDialog from '../AlbumRelease/AlbumReleaseDialog.vue';
import ArtistPlatformProgress from '../ArtistPlatformProgress/index.vue';

export default {
    components: {ArtistSelect, AlbumReleaseDialog, ArtistPlatformProgress},
    props: {
        // 主要艺人
        mainArtist: {
            type: Array,
            default: () => [],
        },
        // 其他艺人
        otherArtist: {
            type: Array,
            default: () => [],
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false,
        },
        // 是否显示其他艺人
        isOtherArtist: {
            type: Boolean,
            default: true,
        },
        // 是否为专辑 true:专辑 false:歌曲
        isAlbum: {
            type: Boolean,
            default: true,
        },
        projectRoleArtistInfo: {
            type: Array,
            default: () => [],
        },
        ifAppleVerify: {
            type: Boolean,
            default: false,
        },
        displayLangCode: {
            type: String,
            default: '',
        },
        // 第三方平台艺人关联统计
        thirdPartyPlatformStats: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            artistTypeOptions: [], // 艺人类型选项
            allArtistInfo: [],
            allArtistValueOptions: [],
            artistProgressData: [],
            progressLoading: false,
        };
    },
    created() {
        this.getArtistType(); // 获取艺人类型选项
        this.setDefaultMainArtist(); // 设置默认主要艺人
        this.setDefaultOtherArtists(); // 设置默认其他艺人
        this.fetchArtistProgress();
    },
    computed: {
        // 获取已选择的艺人类型
        artistTypeSelected() {
            return this.otherArtist.map((item) => item.type);
        },
        hasArtist() {
            return this.mainArtist?.length > 0 || this.otherArtist?.length > 0;
        },
        projectRoleArtistTips() {
            return this.projectRoleArtistInfo?.map((item) => item.label).join(',');
        },
    },
    watch: {
        mainArtist: {
            handler(n) {
                this.allArtistInfo = this.allArtistInfo?.filter((item) => item.type !== 1);
                if (n.length > 0) {
                    //判断：艺人不能同时为主要艺人和合作艺人
                    this.checkIds(1);
                    n.forEach((item) => {
                        this.allArtistInfo?.push({
                            value: item.artistId,
                            name: item.artistName,
                            type: item.type,
                            appleId: item.appleId,
                            spotifyId: item.spotifyId,
                        });
                    });
                }
                this.fetchArtistProgress();
            },
            deep: true,
        },
        otherArtist: {
            handler(n) {
                this.allArtistInfo = this.allArtistInfo?.filter((item) => item.type == 1);
                if (n.length > 0) {
                    n.forEach((item) => {
                        item.artist?.forEach((i) => {
                            this.allArtistInfo?.push({
                                value: i.artistId,
                                name: i.artistName,
                                type: item.type,
                                appleId: i.appleId,
                                spotifyId: i.spotifyId,
                            });
                        });
                    });
                }
                const other = n.filter((item) => item.type === 2 && item.artist?.length > 0);
                if (other.length > 0) {
                    //判断：艺人不能同时为主要艺人和合作艺人
                    this.checkIds(2);
                }
                this.fetchArtistProgress();
            },
            deep: true,
        },
    },
    methods: {
        checkIds(value) {
            const other = this.otherArtist.filter((item) => item.type === 2 && item.artist?.length > 0);
            const mainIds = this.mainArtist.map((item) => item.artistId);
            let coopIds = [];
            if (other.length > 0) {
                coopIds = other[0].artist?.map((item) => item.artistId);
            }
            const ids = [...new Set(mainIds)].filter((id) => coopIds.includes(id));
            if (ids.length > 0) {
                this.$message.error('艺人不能同时为主要艺人和合作艺人');
                if (value == 1) {
                    const newArr = this.mainArtist.filter((item) => !coopIds.includes(item.artistId));
                    this.$emit('update:mainArtist', newArr);
                } else {
                    let newOtherArr = this.otherArtist || [];
                    const targetArtist = this.otherArtist.find((item) => item.type === 2);
                    const idx = this.otherArtist.findIndex((item) => item.type === 2);
                    if (targetArtist) {
                        const children = targetArtist.artist.filter((item) => !ids.includes(item.artistId));
                        newOtherArr[idx].artist = children;
                        this.$emit('update:otherArtist', newOtherArr);
                    }
                }
            }
        },
        // 获取艺人类型选项
        async getArtistType() {
            try {
                const res = await fetchArtistType();
                const {state, result} = res.data;
                if (state && result) {
                    this.artistTypeOptions = result
                        .map((item) => ({label: item.name, value: item.value}))
                        .filter((item) => ![1].includes(item.value)); // 过滤掉不需要的艺人类型
                    this.allArtistValueOptions = result.map((item) => ({
                        isRole: 0,
                        name: item.name,
                        value: item.value,
                    }));
                }
            } catch (error) {
                this.$message.error('获取艺人类型失败');
            }
        },
        // 设置默认主要艺人
        setDefaultMainArtist() {
            const user = this.$store.state.userInfo;
            if (user && this.mainArtist.length === 0) {
                const {artistId, artistName} = user;
                if (artistId && artistName) {
                    this.$emit('update:mainArtist', [{artistId, artistName, type: 1}]);
                }
            }
        },
        // 设置默认其他艺人
        setDefaultOtherArtists() {
            const user = this.$store.state.userInfo;
            if (user) {
                const {artistId, artistName} = user;
                const defaultArtists = [
                    {type: 59, artist: [{artistId, artistName, type: 59}]}, // 录音
                    {type: 10, artist: [{artistId, artistName, type: 10}]}, // 编曲
                ];
                this.$emit('update:otherArtist', [...this.otherArtist, ...defaultArtists]);
            }
        },
        // 获取艺人类型对应的占位符文本
        placeholderText(type) {
            switch (type) {
                case 4:
                    return '除表演语言为"纯音乐"外，作词人必填';
                case 5:
                    return '作曲人为必填信息';
                default:
                    return '请选择艺人';
            }
        },
        // 主要艺人更改处理
        mainArtistChange(value) {
            const formattedValue = value.map((item) => ({...item, type: 1}));
            this.$emit('update:mainArtist', formattedValue);
        },
        // 其他艺人类型更改处理
        otherArtistTypeChange(value, index) {
            const updatedOtherArtist = [...this.otherArtist];
            updatedOtherArtist[index].type = value;
            this.$emit('update:otherArtist', updatedOtherArtist);
        },
        // 其他艺人信息更改处理
        otherArtistChange(value, index) {
            const updatedOtherArtist = [...this.otherArtist];
            updatedOtherArtist[index].artist = value;
            this.$emit('update:otherArtist', updatedOtherArtist);
        },
        // 添加其他艺人
        otherArtistAddItem() {
            const updatedOtherArtist = [...this.otherArtist, {type: '', artist: []}];
            this.$emit('update:otherArtist', updatedOtherArtist);
        },
        // 删除其他艺人
        otherArtistRemoveItem(index) {
            const updatedOtherArtist = this.otherArtist.filter((_, i) => i !== index);
            this.$emit('update:otherArtist', updatedOtherArtist);
        },
        toReleaseArtistDrawer() {
            this.$refs.albumReleaseDialogRef.open();
        },
        /**
         * 获取艺人关联进度
         */
        async fetchArtistProgress() {
            const allArtists = [...this.mainArtist];
            this.otherArtist.forEach(item => {
                if (item.artist && item.artist.length > 0) {
                    allArtists.push(...item.artist);
                }
            });
            if (allArtists.length === 0) {
                this.artistProgressData = [];
                return;
            }
            const ids = [...new Set(allArtists.map(item => item.artistId).filter(Boolean))];
            if (ids.length === 0) {
                this.artistProgressData = [];
                return;
            }
            try {
                this.progressLoading = true;
                const res = await fetchListRelateArtist(ids);
                if (res.data && res.data.state) {
                    this.artistProgressData = res.data.result || [];
                }
            } catch (error) {
                console.error('获取艺人关联进度失败', error);
            } finally {
                this.progressLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.other-artist {
    margin-bottom: 20px;
    display: flex;
    position: relative;

    .el-select:nth-child(1) {
        flex: 1;
        display: block;

        .el-input__inner {
            border-radius: 4px 0 0 4px;
            border-right-width: 0px;
        }
    }

    .artist-select {
        width: 280px;

        .el-select .el-input__inner {
            border-radius: 0 4px 4px 0;
            height: auto;
            border-right-width: 1px;
        }
    }

    .underline {
        position: absolute;
        left: 102%;
        top: 8px;
    }
}
</style>
